import React, { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../../../../components/ActionsVisibilityContext';
import ActionsMenu from '../../../../../components/ActionsMenu';
import { DndGridDragHandle } from '../../../../../components/DndGrid';
import { level1Content } from '../../../../../styles/shareableStyles';
import { IconWrapper } from '../../../../../components/Icon';

interface IProps {
  disabled?: boolean;
  actions?: ReactNode;
  dndId: string;
  rowIndex: number;
  colIndex: number;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr 24px;
  column-gap: 4px;
  width: 100%;
  height: 100%;
  padding: 8px 16px 8px 0;
  ${level1Content};
  .tiptap {
    padding: 0;
  }
`;

const DashboardContentActions = ({
  children,
  actions,
  disabled,
  dndId,
  rowIndex,
  colIndex,
}: PropsWithChildren<IProps>) => {
  const { showActions, hideActions, actionsVisible } =
    useActionsVisibilityContext();

  return (
    <Wrapper onMouseEnter={showActions} onMouseLeave={hideActions}>
      <IconWrapper size={16}>
        <DndGridDragHandle id={dndId} rowIndex={rowIndex} colIndex={colIndex} />
      </IconWrapper>
      {children}
      <IconWrapper size={24}>
        {!disabled && actionsVisible && <ActionsMenu>{actions}</ActionsMenu>}
      </IconWrapper>
    </Wrapper>
  );
};

export default withActionsVisibilityContext(DashboardContentActions);
